import { ReactNode } from 'react';
import styled from 'styled-components';

export const StyledRow = styled.div<{
  children?: ReactNode;
  margin?: string | number;
  styles?: string;
  as?: string | React.ComponentType<any>;
}>`
    margin: ${({ margin }) => margin};
    display: flex;
    flex-wrap: wrap;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: normal;
    justify-content: flex-start;
    ${({ styles }) => styles};
`;

export const StyledColPadding = styled.div<{
  minColWidth?: number;
  col?: number;
}>`
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: ${({ minColWidth }) => minColWidth}px;
  min-width: ${({ col }) => (100 / 12) * col}%;
`;
